export default __webpack_public_path__ + "static/media/in-the-canyon.d08f1529.jpg";